/**
 * Get role text
 * @param {string} role
 * @returns {string}
 * @example
 * getRoleText('Administrador') // returns 'Administrador'
 */

export const getRoleText = (role) => {
  switch (role) {
    case 'Administrador':
      return 'Administrador';
    case 'Capturista':
      return 'Capturista';
    case 'SignosVitales':
      return 'Signos Vitales';
    case 'Triage':
      return 'Triage';
    case 'Doctor':
      return 'Doctor';
    case 'AdminSignos':
      return 'Admin Signos';
    case 'AdminTriage':
      return 'Admin Triage';
    default:
      return
  }
}